if (window.location.pathname.match(/^\/admin\/oav/)) {
    [...document.querySelectorAll('input.required')].forEach(input => {
        input.setAttribute('required', true);
        if (input.parentNode.classList.contains('input-group')){
            input.parentNode.firstElementChild.firstElementChild.innerText += '*';
        } else {
            input.parentNode.firstElementChild.innerText += '*';
        }
    });
    [...document.querySelectorAll('select.required')].forEach(input => {
        input.setAttribute('required', true);
        input.parentNode.firstElementChild.firstElementChild.innerText += '*';
    })
}
